const PRODUCTION_ASSET_PIPELINE_URL = "https://assetpipeline.flux.ai";
const STAGING_ASSET_PIPELINE_URL = "https://assetpipeline-staging.flux.ai";

export function getAssetPipelineCdnBaseUrl(): string {
    if (process.env.REACT_APP_AWS_S3_3D_CDN_CLOUDFRONT_URL) {
        return process.env.REACT_APP_AWS_S3_3D_CDN_CLOUDFRONT_URL;
    }
    if (/^pr-\d+$/i.test(process.env.APPLICATION_ENV ?? "")) {
        return STAGING_ASSET_PIPELINE_URL;
    }
    return PRODUCTION_ASSET_PIPELINE_URL;
}

export function isAssetPipelinePreviewUrl(value: string): boolean {
    return [PRODUCTION_ASSET_PIPELINE_URL, STAGING_ASSET_PIPELINE_URL, getAssetPipelineCdnBaseUrl()].some((baseUrl) =>
        value.startsWith(`${baseUrl}/?`),
    );
}
